<template>
    <div
        v-for="(item, index) in drawResults"
        :key="index"
        class="list-by-date__item"
    >
        <div class="list-by-date__item__flag">
          <img v-lazy="require(`@/assets/images/flags/${item.srcLogo}`)" />
        </div>
        <div class="list-by-date__item__title">
            {{ item.name }}
        </div>
        <div class="list-by-date__item__time">
            {{ $filters.formatDate(item.drawDate) }}
        </div>
        <div class="list-by-date__item__numbers" v-if="item.results.main.length">
            <div
                v-for="(number, i) in item.results.main"
                :key="i"
                class="list-by-date__item__number"
            >
                <a>  {{ number }} </a>
            </div>
            <div
                v-for="(number, i) in item.results.bonus"
                :key="i"
                class="list-by-date__item__number active"
            >
                <a>  {{ number }} </a>
            </div>

        </div>
        <div class="list-by-date__item__numbers cancelled" v-else-if="item.cancelled">
                Cancelled
        </div>
        <div class="list-by-date__item__numbers" v-else>
            N/A
        </div>
        <div @click="handleClickBet(item)" class="list-by-date__item__bet">BET</div>
    </div>
</template>
<script>
    export default {
        props: {
            drawResults: {
                type: Object,
                required: true
            }
        },
        methods: {
            handleClickBet(item) {
                const params = { slug: item.slug, drawName: item.name };
                this.$store.dispatch('addParamsLuckyNumber', params);
                this.$router.push({ name: 'LuckyNumbers' });
            }
        }
    }
</script>
<style scoped lang="scss" src="@/assets/scss/results/listByDate.scss"/>
